/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './admission-advice.reducer';

export const AdmissionAdvice = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const admissionAdviceList = useAppSelector(state => state.admissionAdvice.entities);
  const loading = useAppSelector(state => state.admissionAdvice.loading);
  const totalItems = useAppSelector(state => state.admissionAdvice.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="admission-advice-heading" data-cy="AdmissionAdviceHeading">
        <Translate contentKey="tinyMedicRestApp.admissionAdvice.home.title">Admission Advices</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/admission-advice/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.home.createLabel">Create new Admission Advice</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.admissionAdvice.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {admissionAdviceList && admissionAdviceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('procedureSNId')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.procedureSNId">Procedure SN Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureSNId')} />
                </th>
                <th className="hand" onClick={sort('procedureSNText')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.procedureSNText">Procedure SN Text</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureSNText')} />
                </th>
                <th className="hand" onClick={sort('adviseNotes')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.adviseNotes">Advise Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('adviseNotes')} />
                </th>
                <th className="hand" onClick={sort('instructions')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.instructions">Instructions</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('instructions')} />
                </th>
                <th className="hand" onClick={sort('snomedConceptId')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.snomedConceptId">Snomed Concept Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('snomedConceptId')} />
                </th>
                <th className="hand" onClick={sort('snomedConceptText')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.snomedConceptText">Snomed Concept Text</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('snomedConceptText')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('fulfilled')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.fulfilled">Fulfilled</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('fulfilled')} />
                </th>
                <th className="hand" onClick={sort('emergency')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.emergency">Emergency</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergency')} />
                </th>
                <th className="hand" onClick={sort('highRisk')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.highRisk">High Risk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('highRisk')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th className="hand" onClick={sort('emAdmissionId')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.emAdmissionId">Em Admission Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emAdmissionId')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.proposedProcedure">Proposed Procedure</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.diagnosis">Diagnosis</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.appointment">Appointment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.advicedBy">Adviced By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.admissionAdvice.admitAt">Admit At</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {admissionAdviceList.map((admissionAdvice, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/admission-advice/${admissionAdvice.id}`} color="link" size="sm">
                      {admissionAdvice.id}
                    </Button>
                  </td>
                  <td>{admissionAdvice.procedureSNId}</td>
                  <td>{admissionAdvice.procedureSNText}</td>
                  <td>{admissionAdvice.adviseNotes}</td>
                  <td>{admissionAdvice.instructions}</td>
                  <td>{admissionAdvice.snomedConceptId}</td>
                  <td>{admissionAdvice.snomedConceptText}</td>
                  <td>{admissionAdvice.active ? 'true' : 'false'}</td>
                  <td>{admissionAdvice.timestampentry}</td>
                  <td>{admissionAdvice.microSec}</td>
                  <td>{admissionAdvice.lastupdated}</td>
                  <td>{admissionAdvice.cursor}</td>
                  <td>{admissionAdvice.fulfilled ? 'true' : 'false'}</td>
                  <td>{admissionAdvice.emergency ? 'true' : 'false'}</td>
                  <td>{admissionAdvice.highRisk ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${admissionAdvice.modifiedByType}`} />
                  </td>
                  <td>{admissionAdvice.modifiedByID}</td>
                  <td>{admissionAdvice.emAdmissionId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AdmissionType.${admissionAdvice.type}`} />
                  </td>
                  <td>
                    {admissionAdvice.proposedProcedure ? (
                      <Link to={`/icd-10-procedure/${admissionAdvice.proposedProcedure.id}`}>{admissionAdvice.proposedProcedure.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {admissionAdvice.diagnosis ? (
                      <Link to={`/icd-10-diagnosis/${admissionAdvice.diagnosis.id}`}>{admissionAdvice.diagnosis.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {admissionAdvice.appointment ? (
                      <Link to={`/appointments/${admissionAdvice.appointment.id}`}>{admissionAdvice.appointment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {admissionAdvice.advicedBy ? (
                      <Link to={`/doctor/${admissionAdvice.advicedBy.id}`}>{admissionAdvice.advicedBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {admissionAdvice.patient ? (
                      <Link to={`/gluco-user/${admissionAdvice.patient.id}`}>{admissionAdvice.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {admissionAdvice.admitAt ? (
                      <Link to={`/hospital/${admissionAdvice.admitAt.id}`}>{admissionAdvice.admitAt.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/admission-advice/${admissionAdvice.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/admission-advice/${admissionAdvice.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/admission-advice/${admissionAdvice.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.admissionAdvice.home.notFound">No Admission Advices found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={admissionAdviceList && admissionAdviceList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AdmissionAdvice;
